var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9392 2.21L9.52922 7.82H7.11922C6.71922 7.82 6.32922 7.85 5.94922 7.93L6.94922 5.53L6.98922 5.44L7.04922 5.28C7.07922 5.21 7.09922 5.15 7.12922 5.1C8.28922 2.41 9.58922 1.57 11.9392 2.21Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7291 8.09L18.7091 8.08C18.1091 7.91 17.4991 7.82 16.8791 7.82H10.6191L12.8691 2.59L12.8991 2.52C13.0391 2.57 13.1891 2.64 13.3391 2.69L15.5491 3.62C16.7791 4.13 17.6391 4.66 18.1691 5.3C18.2591 5.42 18.3391 5.53 18.4191 5.66C18.5091 5.8 18.5791 5.94 18.6191 6.09C18.6591 6.18 18.6891 6.26 18.7091 6.35C18.8591 6.86 18.8691 7.44 18.7291 8.09Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5195 17.66H12.7695C13.0695 17.66 13.3195 17.39 13.3195 17.06C13.3195 16.64 13.1995 16.58 12.9395 16.48L12.5195 16.33V17.66Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.2902 9.52C17.8402 9.39 17.3702 9.32 16.8802 9.32H7.12023C6.44023 9.32 5.80023 9.45 5.20023 9.71C3.46023 10.46 2.24023 12.19 2.24023 14.2V16.15C2.24023 16.39 2.26023 16.62 2.29023 16.86C2.51023 20.04 4.21023 21.74 7.39023 21.95C7.62023 21.98 7.85023 22 8.10023 22H15.9002C19.6002 22 21.5502 20.24 21.7402 16.74C21.7502 16.55 21.7602 16.35 21.7602 16.15V14.2C21.7602 11.99 20.2902 10.13 18.2902 9.52ZM13.2802 15.5C13.7402 15.66 14.3602 16 14.3602 17.06C14.3602 17.97 13.6502 18.7 12.7702 18.7H12.5202V18.92C12.5202 19.21 12.2902 19.44 12.0002 19.44C11.7102 19.44 11.4802 19.21 11.4802 18.92V18.7H11.3902C10.4302 18.7 9.64023 17.89 9.64023 16.89C9.64023 16.6 9.87023 16.37 10.1602 16.37C10.4502 16.37 10.6802 16.6 10.6802 16.89C10.6802 17.31 11.0002 17.66 11.3902 17.66H11.4802V15.97L10.7202 15.7C10.2602 15.54 9.64023 15.2 9.64023 14.14C9.64023 13.23 10.3502 12.5 11.2302 12.5H11.4802V12.28C11.4802 11.99 11.7102 11.76 12.0002 11.76C12.2902 11.76 12.5202 11.99 12.5202 12.28V12.5H12.6102C13.5702 12.5 14.3602 13.31 14.3602 14.31C14.3602 14.6 14.1302 14.83 13.8402 14.83C13.5502 14.83 13.3202 14.6 13.3202 14.31C13.3202 13.89 13.0002 13.54 12.6102 13.54H12.5202V15.23L13.2802 15.5Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.6797 14.14C10.6797 14.56 10.7997 14.62 11.0597 14.72L11.4797 14.87V13.54H11.2297C10.9197 13.54 10.6797 13.81 10.6797 14.14Z",
    fill: "#A9B7BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.77acb856f88d4d0fc9ad28894fcf231d.svg";
export { ForwardRef as ReactComponent };